import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';
import { Color } from '../styles';

export function Eye(props: IconProps) {
  const { baseColor = Color.Kale3, size = 24, ...svgProps } = props;
  return (
    <IconSvg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      {...svgProps}
      fill="none"
    >
      <path
        d="M3.16271 12.8291C2.9368 12.57 2.75759 12.351 2.63023 12.1905C2.75759 12.0299 2.9368 11.8109 3.16271 11.5518C3.6571 10.9848 4.37206 10.2294 5.2539 9.47523C7.03278 7.95393 9.41799 6.5 12 6.5C14.582 6.5 16.9672 7.95393 18.7461 9.47523C19.6279 10.2294 20.3429 10.9848 20.8373 11.5518C21.0632 11.8109 21.2424 12.0299 21.3698 12.1905C21.2424 12.351 21.0632 12.57 20.8373 12.8291C20.3429 13.3961 19.6279 14.1516 18.7461 14.9057C16.9672 16.427 14.582 17.881 12 17.881C9.41799 17.881 7.03278 16.427 5.2539 14.9057C4.37206 14.1516 3.6571 13.3961 3.16271 12.8291Z"
        stroke={baseColor}
      ></path>
      <circle cx="12" cy="12" r="2.5" stroke={baseColor}></circle>
    </IconSvg>
  );
}
